import type { LifeEvent } from '../../types/onelife.ts';

export const PRIMARY_EVENTS: LifeEvent[] = [
  {
    "id": "pr_01_first_day_school",
    "stageKey": "primary",
    "age": 6,
    "titleVi": "Ngày Khai Trường Lớp 1",
    "descriptionVi": "Lễ khai giảng đầu đời với cờ hoa rực rỡ, tiếng trống trường vang vọng xao xuyến.",
    "category": "education",
    "choices": [
      {
        "id": "pr_01_a",
        "textVi": "Nghiêm trang chào cờ và xung phong đọc bài to rõ trước lớp",
        "outcomeTextVi": "Cô giáo khen ngợi bạn tự tin và bầu làm tổ trưởng gương mẫu.",
        "healthDelta": 5,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 10,
        "unlockEducation": "Tiểu Học Cơ Bản"
      },
      {
        "id": "pr_01_b",
        "textVi": "Cùng nhóm bạn cùng bàn chia nhau kẹo và làm quen",
        "outcomeTextVi": "Bạn nhanh chóng kết thân với nhiều bạn tốt ngay ngày đầu tiên.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": -5,
        "intellectDelta": 5,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "pr_02_first_communion",
    "stageKey": "primary",
    "age": 8,
    "titleVi": "Bí Tích Thánh Thể & Rước Lễ Lần Đầu",
    "descriptionVi": "Sau 2 năm kiên trì học giáo lý và xưng tội trong Bí Tích Hòa Giải, bạn mặc lễ phục trắng chuẩn bị Rước Mình Thánh Chúa.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "pr_02_a",
        "textVi": "Trang nghiêm tiến lên bàn thánh sốt sắng đón nhận Bí Tích Thánh Thể",
        "outcomeTextVi": "Tâm hồn ngập tràn bình an thánh thiện. Bí Tích Thánh Thể trở thành nguồn trợ lực suốt đời bạn.",
        "healthDelta": 10,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 15,
        "addSacrament": "Bí Tích Thánh Thể",
        "addVirtue": "Lãnh nhận Bí Tích Thánh Thể với tâm hồn thanh sạch và niềm tôn kính sâu sắc"
      },
      {
        "id": "pr_02_b",
        "textVi": "Cùng cả lớp giáo lý nhi đồng hát vang bài ca tạ ơn",
        "outcomeTextVi": "Cha xứ và cộng đoàn vỗ tay chúc mừng. Tình đoàn kết xóm đạo thêm gắn kết.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 25,
        "addSacrament": "Bí Tích Thánh Thể"
      }
    ]
  },
  {
    "id": "pr_03_math_contest",
    "stageKey": "primary",
    "age": 9,
    "titleVi": "Kỳ Thi Toán Học Tuổi Thơ",
    "descriptionVi": "Trường phát động kỳ thi giải toán nhanh trên máy tính hoặc bảng con cho học sinh khối 4.",
    "category": "education",
    "choices": [
      {
        "id": "pr_03_a",
        "textVi": "Tập trung rèn luyện đề thi mẫu mỗi tối",
        "outcomeTextVi": "Bạn đạt giải Nhì cấp trường, bố mẹ tự hào thưởng một chuyến dã ngoại.",
        "healthDelta": 0,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 10,
        "unlockAchievement": "Thần Đồng Toán Học Nhỏ"
      },
      {
        "id": "pr_03_b",
        "textVi": "Tham gia với tinh thần vui vẻ, không áp lực điểm số",
        "outcomeTextVi": "Bạn giải toán sáng tạo và tìm thấy niềm say mê khám phá những con số.",
        "healthDelta": 5,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 5
      }
    ]
  },
  {
    "id": "pr_04_chores_help",
    "stageKey": "primary",
    "age": 7,
    "titleVi": "Phụ Giúp Việc Nhà",
    "descriptionVi": "Thấy cha mẹ đi làm vất vả, bạn tự giác quét nhà, nhặt rau và rửa bát.",
    "category": "family",
    "choices": [
      {
        "id": "pr_04_a",
        "textVi": "Chăm chỉ hoàn thành mọi việc nhà trước khi cha mẹ đi làm về",
        "outcomeTextVi": "Cha mẹ ấm lòng ôm bạn vào lòng, cả nhà quây quần bên mâm cơm ấm cúng.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 5,
        "intellectDelta": 5,
        "relationsDelta": 20,
        "addVirtue": "Hiếu thảo phụ giúp cha mẹ từ tấm bé"
      },
      {
        "id": "pr_04_b",
        "textVi": "Vừa làm vừa bày trò chơi thổi bong bóng xà phòng",
        "outcomeTextVi": "Tuy làm hơi chậm nhưng ngôi nhà luôn rộn rã tiếng cười vui tươi.",
        "healthDelta": 5,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 10
      }
    ]
  },
  {
    "id": "pr_05_swimming",
    "stageKey": "primary",
    "age": 8,
    "titleVi": "Học Bơi Mùa Hè",
    "descriptionVi": "Vào kỳ nghỉ hè, xóm mở lớp phổ cập bơi lội an toàn phòng tránh đuối nước.",
    "category": "health",
    "choices": [
      {
        "id": "pr_05_a",
        "textVi": "Kiên trì tập thở nước và quẫy chân theo chỉ dẫn của thầy",
        "outcomeTextVi": "Sau 2 tuần bạn đã bơi thành thạo cự ly 50m, thể lực dẻo dai khỏe khoắn.",
        "healthDelta": 20,
        "happinessDelta": 15,
        "wealthDelta": -5,
        "intellectDelta": 5,
        "relationsDelta": 10
      },
      {
        "id": "pr_05_b",
        "textVi": "Sợ nước, chỉ dám đứng trên bờ té nước cùng bạn bè",
        "outcomeTextVi": "Bạn có những kỷ niệm hè vui nhộn nhưng vẫn chưa biết bơi.",
        "healthDelta": 0,
        "happinessDelta": 10,
        "wealthDelta": 0,
        "intellectDelta": 0,
        "relationsDelta": 15
      }
    ]
  },
  {
    "id": "pr_06_bullying",
    "stageKey": "primary",
    "age": 9,
    "titleVi": "Bênh Vực Bạn Yếu",
    "descriptionVi": "Ở sân trường, một bạn nhỏ bị nhóm học sinh cá biệt trêu chọc và giật cặp sách.",
    "category": "society",
    "choices": [
      {
        "id": "pr_06_a",
        "textVi": "Dũng cảm bước ra can ngăn và báo ngay cho thầy cô giám thị",
        "outcomeTextVi": "Sự việc được can thiệp kịp thời, bạn được tuyên dương trước toàn trường.",
        "healthDelta": 0,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 20,
        "addVirtue": "Lòng trắc ẩn và tinh thần dũng cảm bảo vệ người cô thế"
      },
      {
        "id": "pr_06_b",
        "textVi": "Đưa bạn nhỏ chạy thoát vào phòng y tế lánh nạn",
        "outcomeTextVi": "Cả hai an toàn, bạn nhỏ từ đó xem bạn như tri kỷ thân thiết nhất.",
        "healthDelta": 5,
        "happinessDelta": 10,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "pr_07_altar_server",
    "stageKey": "primary",
    "age": 10,
    "titleVi": "Đoàn Lễ Sinh Giáo Xứ",
    "descriptionVi": "Cha xứ tuyển các em thiếu nhi vào đội giúp lễ (lễ sinh) phụng vụ bàn thánh mỗi Thánh Lễ.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "pr_07_a",
        "textVi": "Hăng hái đăng ký tập dượt nghi thức phụng vụ và áo giúp lễ",
        "outcomeTextVi": "Bạn phục vụ bàn thờ Chúa với tâm tình trang nghiêm, rèn đức tính cẩn trọng, kỷ luật.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 20,
        "addVirtue": "Nhiệt thành phục vụ bàn thánh qua bổn phận lễ sinh sốt sắng"
      },
      {
        "id": "pr_07_b",
        "textVi": "Gia nhập ca đoàn thiếu nhi hát thánh ca Chúa Nhật",
        "outcomeTextVi": "Giọng hát trong trẻo của bạn hòa vào lời ca thánh thót nâng đỡ tâm hồn cộng đoàn.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "pr_08_pet_rescue",
    "stageKey": "primary",
    "age": 7,
    "titleVi": "Chú Chó Nhỏ Bị Bỏ Rơi",
    "descriptionVi": "Trên đường đi học về trong mưa phùn, bạn bắt gặp một chú chó con ướt sũng bên lề đường.",
    "category": "family",
    "choices": [
      {
        "id": "pr_08_a",
        "textVi": "Ôm chú cún về xin phép cha mẹ cho nuôi nấng",
        "outcomeTextVi": "Gia đình đồng ý. Chú cún trở thành người bạn trung thành lớn lên cùng bạn.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": -5,
        "intellectDelta": 5,
        "relationsDelta": 15
      },
      {
        "id": "pr_08_b",
        "textVi": "Gõ cửa tiệm bánh gần đó gửi nhờ họ cho chú cún ăn và tìm chủ",
        "outcomeTextVi": "Bác chủ tiệm tốt bụng nhận nuôi luôn, khen bạn là đứa trẻ có lòng nhân hậu.",
        "healthDelta": 0,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 15
      }
    ]
  },
  {
    "id": "pr_09_reading_habit",
    "stageKey": "primary",
    "age": 8,
    "titleVi": "Thư Viện Trường Tiểu Học",
    "descriptionVi": "Thư viện trường mở cửa giờ ra chơi với hàng trăm cuốn truyện tranh lịch sử và khoa học kỳ thú.",
    "category": "education",
    "choices": [
      {
        "id": "pr_09_a",
        "textVi": "Dành toàn bộ giờ ra chơi say sưa đọc sách bách khoa tri thức",
        "outcomeTextVi": "Tầm hiểu biết của bạn mở rộng nhanh chóng, luôn có câu trả lời sắc sảo trên lớp.",
        "healthDelta": 0,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 25,
        "relationsDelta": 5
      },
      {
        "id": "pr_09_b",
        "textVi": "Đọc truyện cổ tích cùng các bạn và cùng diễn lại kịch",
        "outcomeTextVi": "Trí tưởng tượng bay bổng và khả năng giao tiếp của bạn phát triển toàn diện.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 15
      }
    ]
  },
  {
    "id": "pr_10_music_lesson",
    "stageKey": "primary",
    "age": 9,
    "titleVi": "Tiếng Đàn Organ / Sáo Trúc",
    "descriptionVi": "Nhà trường mở câu lạc bộ âm nhạc dân tộc và đàn phím điện tử.",
    "category": "education",
    "choices": [
      {
        "id": "pr_10_a",
        "textVi": "Tập trung luyện ngón đàn mỗi ngày nửa tiếng",
        "outcomeTextVi": "Bạn chơi đàn lưu loát, được chọn biểu diễn trong đêm văn nghệ của trường.",
        "healthDelta": 0,
        "happinessDelta": 20,
        "wealthDelta": -5,
        "intellectDelta": 15,
        "relationsDelta": 15
      },
      {
        "id": "pr_10_b",
        "textVi": "Học thổi sáo trúc dân dã, du dương",
        "outcomeTextVi": "Âm thanh thanh thoát rèn luyện hơi thở sâu và tình yêu quê hương đất nước.",
        "healthDelta": 10,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 10
      }
    ]
  },
  {
    "id": "pr_11_broken_vase",
    "stageKey": "primary",
    "age": 10,
    "titleVi": "Chiếc Bình Hoa Bị Vỡ",
    "descriptionVi": "Trong lúc đá bóng trong nhà, bạn vô tình sút trúng bình hoa gốm quý của gia đình.",
    "category": "family",
    "choices": [
      {
        "id": "pr_11_a",
        "textVi": "Trung thực nhận lỗi ngay khi cha mẹ về và xin làm việc nhà trừ nợ",
        "outcomeTextVi": "Cha mẹ khen ngợi lòng trung thực, dạy bạn bài học về trách nhiệm và cẩn thận.",
        "healthDelta": 0,
        "happinessDelta": 10,
        "wealthDelta": -10,
        "intellectDelta": 10,
        "relationsDelta": 15,
        "addVirtue": "Lòng trung thực can đảm nhận lỗi và sửa sai"
      },
      {
        "id": "pr_11_b",
        "textVi": "Lặng lẽ dọn dẹp sạch mảnh vỡ để không ai bị thương",
        "outcomeTextVi": "Bạn giữ an toàn cho mọi người nhưng mang nỗi băn khoăn cho tới khi thú nhận.",
        "healthDelta": 0,
        "happinessDelta": -5,
        "wealthDelta": -5,
        "intellectDelta": 5,
        "relationsDelta": 5
      }
    ]
  },
  {
    "id": "pr_12_scout_camp",
    "stageKey": "primary",
    "age": 11,
    "titleVi": "Cắm Trại Hè Hướng Đạo Sinh",
    "descriptionVi": "Chuyến dã ngoại 3 ngày 2 đêm tại đồi thông, rèn luyện kỹ năng sinh tồn và làm việc nhóm.",
    "category": "society",
    "choices": [
      {
        "id": "pr_12_a",
        "textVi": "Học cách thắt nút dây, dựng lều và nấu ăn bằng củi khô",
        "outcomeTextVi": "Bạn tự tin làm chủ các kỹ năng ngoài trời, trở thành đội trưởng gương mẫu.",
        "healthDelta": 15,
        "happinessDelta": 20,
        "wealthDelta": -5,
        "intellectDelta": 15,
        "relationsDelta": 20
      },
      {
        "id": "pr_12_b",
        "textVi": "Tham gia trò chơi đêm giải mật mã và ngắm sao",
        "outcomeTextVi": "Một đêm hè huyền diệu dưới bầu trời sao in sâu vào tâm trí bạn suốt nhiều năm.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": -5,
        "intellectDelta": 15,
        "relationsDelta": 15
      }
    ]
  },
  {
    "id": "pr_13_penmanship",
    "stageKey": "primary",
    "age": 7,
    "titleVi": "Hội Thi Vở Sạch Chữ Đẹp",
    "descriptionVi": "Phong trào rèn nét chữ nết người được phát động trên toàn thị trấn.",
    "category": "education",
    "choices": [
      {
        "id": "pr_13_a",
        "textVi": "Kiên nhẫn nắn nót từng nét thanh nét đậm mực tím",
        "outcomeTextVi": "Bạn đạt giải Nhất toàn trường, được khen ngợi tính cách chỉn chu, kiên định.",
        "healthDelta": 0,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 10
      },
      {
        "id": "pr_13_b",
        "textVi": "Viết phóng khoáng, ưu tiên tốc độ ghi chép nhanh",
        "outcomeTextVi": "Nét chữ hơi thô nhưng bạn tư duy nhanh nhạy, làm bài tập trước cả lớp.",
        "healthDelta": 0,
        "happinessDelta": 10,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 5
      }
    ]
  },
  {
    "id": "pr_14_soccer_match",
    "stageKey": "primary",
    "age": 10,
    "titleVi": "Trận Chung Kết Bóng Đá Nhi Đồng",
    "descriptionVi": "Đội bóng xóm bạn vào chung kết giải bóng đá thiếu niên hè, tỷ số hòa 1-1 nghẹt thở.",
    "category": "health",
    "choices": [
      {
        "id": "pr_14_a",
        "textVi": "Thực hiện quả đá luân lưu quyết định với sự bình tĩnh tuyệt đối",
        "outcomeTextVi": "Bóng găm thẳng góc chết! Đội bạn nâng cao cúp vô địch trong tiếng reo hò rực rỡ.",
        "healthDelta": 15,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 20,
        "unlockAchievement": "Nhà Vô Địch Nhí"
      },
      {
        "id": "pr_14_b",
        "textVi": "Làm thủ môn lăn xả cản phá bóng bất chấp trầy xước",
        "outcomeTextVi": "Tinh thần quả cảm của bạn giữ sạch mành lưới và truyền cảm hứng cho toàn đội.",
        "healthDelta": 10,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "pr_15_family_harvest",
    "stageKey": "primary",
    "age": 11,
    "titleVi": "Mùa Vụ Thu Hoạch Nông Sản",
    "descriptionVi": "Cánh đồng quê vào vụ gặt rộ, cả gia đình thức dậy từ 4 giờ sáng.",
    "category": "family",
    "choices": [
      {
        "id": "pr_15_a",
        "textVi": "Ra đồng gánh lúa và phụ phơi thóc dưới nắng vàng",
        "outcomeTextVi": "Bạn thấu hiểu mồ hôi nước mắt của nhà nông, quý trọng từng hạt gạo bát cơm.",
        "healthDelta": 15,
        "happinessDelta": 10,
        "wealthDelta": 10,
        "intellectDelta": 5,
        "relationsDelta": 15,
        "addVirtue": "Thấm thía giá trị lao động và biết ơn hạt cơm manh áo"
      },
      {
        "id": "pr_15_b",
        "textVi": "Ở nhà trông em nhỏ và nấu nước chè xanh mang ra đồng cho cha mẹ",
        "outcomeTextVi": "Nồi nước chè ngọt lành xua tan mệt mỏi cho cả nhà.",
        "healthDelta": 5,
        "happinessDelta": 15,
        "wealthDelta": 5,
        "intellectDelta": 5,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "pr_16_confession_prep",
    "stageKey": "primary",
    "age": 9,
    "titleVi": "Bí Tích Hòa Giải Đầu Đời",
    "descriptionVi": "Trước ngày lễ lớn, cha xứ ngồi tòa giải tội lắng nghe tâm tư và ban ơn tha thứ trong Bí Tích Hòa Giải.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "pr_16_a",
        "textVi": "Thành tâm xét mình, sám hối và xưng tội thật thà trong Bí Tích Hòa Giải",
        "outcomeTextVi": "Tâm hồn bạn nhẹ nhõm như vừa trút bỏ gánh nặng, tràn ngập ơn an bình của Chúa.",
        "healthDelta": 10,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 15,
        "addSacrament": "Bí Tích Hòa Giải",
        "addVirtue": "Biết khiêm nhường xét mình và can đảm xưng thú tội lỗi trong Bí Tích Hòa Giải"
      },
      {
        "id": "pr_16_b",
        "textVi": "Làm việc đền tội bằng việc làm hòa với bạn bè mình từng giận dỗi",
        "outcomeTextVi": "Tình bạn được hàn gắn đẹp đẽ, lòng bác ái nở hoa trong đời sống hàng ngày.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 25,
        "addSacrament": "Bí Tích Hòa Giải"
      }
    ]
  },
  {
    "id": "pr_17_bicycle",
    "stageKey": "primary",
    "age": 9,
    "titleVi": "Tập Đi Xe Đạp Hai Bánh",
    "descriptionVi": "Chiếc xe đạp nhỏ cha tháo bỏ hai bánh phụ, bạn bắt đầu tự giữ thăng bằng.",
    "category": "health",
    "choices": [
      {
        "id": "pr_17_a",
        "textVi": "Dù ngã trầy đầu gối vẫn đứng dậy đạp tiếp cho đến khi lướt đi êm ru",
        "outcomeTextVi": "Cảm giác gió lướt qua tai thật tuyệt vời! Bạn làm chủ chiếc xe sau một buổi chiều.",
        "healthDelta": 10,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 10
      },
      {
        "id": "pr_17_b",
        "textVi": "Nhờ cha vịn yên sau chạy theo thật lâu",
        "outcomeTextVi": "Tiếng cười của hai cha con rộn rã khắp con ngõ nhỏ.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 0,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "pr_18_science_fair",
    "stageKey": "primary",
    "age": 11,
    "titleVi": "Ngày Hội Khoa Học Tuổi Thơ",
    "descriptionVi": "Bạn làm mô hình núi lửa phun trào bằng bột nở và giấm hoặc đèn kéo quân tự quay bằng nến.",
    "category": "education",
    "choices": [
      {
        "id": "pr_18_a",
        "textVi": "Tự mày mò lắp ráp mạch điện thắp sáng ngôi nhà giấy",
        "outcomeTextVi": "Mô hình phát sáng lung linh, bạn nhận giải Sáng Tạo Nhí của trường.",
        "healthDelta": 0,
        "happinessDelta": 20,
        "wealthDelta": -5,
        "intellectDelta": 25,
        "relationsDelta": 10
      },
      {
        "id": "pr_18_b",
        "textVi": "Làm thí nghiệm lọc nước sinh học từ cát sỏi và than hoạt tính",
        "outcomeTextVi": "Ý thức bảo vệ nguồn nước sạch của bạn được các thầy cô đánh giá rất cao.",
        "healthDelta": 5,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 10
      }
    ]
  },
  {
    "id": "pr_19_stormy_night",
    "stageKey": "primary",
    "age": 10,
    "titleVi": "Đêm Bão Mất Điện",
    "descriptionVi": "Một cơn bão lớn tràn qua, sấm chớp ầm ầm và cả thị trấn chìm trong bóng tối.",
    "category": "family",
    "choices": [
      {
        "id": "pr_19_a",
        "textVi": "Cùng mẹ thắp nến và đọc truyện cổ tích cho các em nghe đỡ sợ",
        "outcomeTextVi": "Ngọn nến ấm áp xua tan nỗi sợ hãi, gắn kết tình cảm gia đình bền chặt.",
        "healthDelta": 5,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 25
      },
      {
        "id": "pr_19_b",
        "textVi": "Cùng cha chằng chống lại mái hiên và cửa sổ phòng gió giật",
        "outcomeTextVi": "Bạn rèn luyện được tinh thần bình tĩnh, dám đối diện hiểm nguy.",
        "healthDelta": 10,
        "happinessDelta": 10,
        "wealthDelta": 5,
        "intellectDelta": 10,
        "relationsDelta": 15
      }
    ]
  },
  {
    "id": "pr_20_piggy_bank",
    "stageKey": "primary",
    "age": 8,
    "titleVi": "Nuôi Heo Đất Tiết Kiệm",
    "descriptionVi": "Bạn được tặng một chú heo đất gốm để nuôi những đồng tiền mừng tuổi đầu năm.",
    "category": "career",
    "choices": [
      {
        "id": "pr_20_a",
        "textVi": "Kiên trì nhịn quà vặt, bỏ ống đều đặn mỗi tuần",
        "outcomeTextVi": "Cuối năm đập heo, bạn đủ tiền mua bộ sách mới và mua tặng mẹ chiếc khăn ấm.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 15,
        "intellectDelta": 10,
        "relationsDelta": 15,
        "addVirtue": "Biết tiết kiệm cần kiệm và nghĩ đến người thân"
      },
      {
        "id": "pr_20_b",
        "textVi": "Dùng một nửa tiền ống heo ủng hộ đồng bào chịu thiên tai bão lụt",
        "outcomeTextVi": "Lòng trắc ẩn thơm thảo của bạn được ghi nhận vào sổ vàng chữ thập đỏ.",
        "healthDelta": 0,
        "happinessDelta": 25,
        "wealthDelta": -5,
        "intellectDelta": 5,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "pr_21_drawing_contest",
    "stageKey": "primary",
    "age": 7,
    "titleVi": "Vẽ Tranh Ước Mơ Tuổi Thơ",
    "descriptionVi": "Cuộc thi vẽ tranh chủ đề \"Thế giới hòa bình và tương lai xanh\" dành cho thiếu nhi.",
    "category": "education",
    "choices": [
      {
        "id": "pr_21_a",
        "textVi": "Vẽ cánh đồng quê hương yên bình bên dòng sông xanh ngắt",
        "outcomeTextVi": "Bức tranh đong đầy cảm xúc đoạt giải Nhất và được treo trang trọng ở sảnh trường.",
        "healthDelta": 0,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 15
      },
      {
        "id": "pr_21_b",
        "textVi": "Vẽ tàu vũ trụ đưa các bạn nhỏ bay lên thám hiểm các vì sao",
        "outcomeTextVi": "Sự sáng tạo vô biên của bạn khiến thầy cô và bạn bè trầm trồ thích thú.",
        "healthDelta": 0,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 10
      }
    ]
  },
  {
    "id": "pr_22_grandma_stories",
    "stageKey": "primary",
    "age": 10,
    "titleVi": "Những Câu Chuyện Bên Khung Cửi Của Bà",
    "descriptionVi": "Mỗi buổi trưa hè, bà kể cho bạn nghe chuyện đời xưa, ca dao tục ngữ và nguồn gốc tổ tiên.",
    "category": "family",
    "choices": [
      {
        "id": "pr_22_a",
        "textVi": "Chăm chú lắng nghe và ghi chép lại những bài ca dao vào sổ tay",
        "outcomeTextVi": "Bạn được bồi đắp tâm hồn sâu sắc bởi truyền thống cội nguồn dân tộc.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 20,
        "addVirtue": "Kính trọng ông bà tổ tiên và trân quý di sản văn hóa"
      },
      {
        "id": "pr_22_b",
        "textVi": "Đấm lưng xoa bóp tay chân cho bà đỡ nhức mỏi",
        "outcomeTextVi": "Bà mỉm cười xoa đầu bạn, cầu chúc cho bạn một đời hiền hòa, phúc đức.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "pr_23_chess_match",
    "stageKey": "primary",
    "age": 11,
    "titleVi": "Ván Cờ Tướng / Cờ Vua Cùng Ông",
    "descriptionVi": "Ông nội dạy bạn cách đi từng quân cờ Mã, Xe, Pháo dưới bóng cây đa đầu ngõ.",
    "category": "education",
    "choices": [
      {
        "id": "pr_23_a",
        "textVi": "Học cách kiên nhẫn tính toán từng nước đi trước khi đặt quân",
        "outcomeTextVi": "Bạn rèn được tư duy chiến thuật sắc sảo, không còn hấp tấp, vội vàng.",
        "healthDelta": 0,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 25,
        "relationsDelta": 15
      },
      {
        "id": "pr_23_b",
        "textVi": "Thích phong cách tấn công dồn dập, thí quân đổi tướng",
        "outcomeTextVi": "Ván cờ sôi nổi khiến các cụ già trong xóm vây quanh tán thưởng tấm tắc.",
        "healthDelta": 0,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "pr_24_school_play",
    "stageKey": "primary",
    "age": 12,
    "titleVi": "Vở Kịch Đêm Bế Giảng",
    "descriptionVi": "Lễ tổng kết năm học lớp 5 chuẩn bị chia tay mái trường tiểu học thân thương.",
    "category": "education",
    "choices": [
      {
        "id": "pr_24_a",
        "textVi": "Đóng vai nhân vật chính trong vở kịch lịch sử tri ân thầy cô",
        "outcomeTextVi": "Tiếng vỗ tay vang dội sảnh đường, nhiều giọt nước mắt xúc động lăn trên má.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 20
      },
      {
        "id": "pr_24_b",
        "textVi": "Phụ trách âm thanh ánh sáng và hậu cần sân khấu",
        "outcomeTextVi": "Vở kịch thành công rực rỡ nhờ sự thầm lặng cống hiến đầy trách nhiệm của bạn.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "pr_25_friendship_promise",
    "stageKey": "primary",
    "age": 12,
    "titleVi": "Lời Hẹn Cây Phượng Vĩ",
    "descriptionVi": "Hoa phượng đỏ rực báo hiệu mùa hè cuối cùng của thời tiểu học, nhóm bạn thân cùng viết lưu bút.",
    "category": "love",
    "choices": [
      {
        "id": "pr_25_a",
        "textVi": "Cùng chôn chiếc lọ điều ước dưới gốc phượng hẹn ngày hội ngộ",
        "outcomeTextVi": "Tình bạn thời thơ ấu trở thành mỏ neo ký ức êm đềm nâng đỡ bạn qua giông bão.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 25
      },
      {
        "id": "pr_25_b",
        "textVi": "Tặng nhau những cuốn tập và chiếc bút mực kỷ niệm",
        "outcomeTextVi": "Những món quà mộc mạc lưu giữ tình bạn hồn nhiên trong sáng.",
        "healthDelta": 0,
        "happinessDelta": 20,
        "wealthDelta": -5,
        "intellectDelta": 5,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "pr_26_middle_school_prep",
    "stageKey": "primary",
    "age": 12,
    "titleVi": "Bước Vào Ngưỡng Cửa Trung Học",
    "descriptionVi": "Bạn nhận giấy báo trúng tuyển trường trung học cơ sở điểm của huyện/quận.",
    "category": "education",
    "choices": [
      {
        "id": "pr_26_a",
        "textVi": "Tự tin đặt mục tiêu học sinh xuất sắc và tham gia ban cán sự lớp",
        "outcomeTextVi": "Khí thế mạnh mẽ giúp bạn sẵn sàng chinh phục chân trời tri thức mới.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 10,
        "unlockEducation": "Hoàn Thành Tiểu Học Khá Giỏi"
      },
      {
        "id": "pr_26_b",
        "textVi": "Dành kỳ nghỉ hè cuối cùng vui chơi thỏa thích cùng bạn bè xóm làng",
        "outcomeTextVi": "Tâm trí thoải mái, tinh thần phấn chấn chuẩn bị cho chặng đường mới.",
        "healthDelta": 15,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 15
      }
    ]
  }
];
